export default __webpack_public_path__ + "static/media/arrow-down.79e8e66c.svg";